import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";
import { isDialogOpen, setDialog } from "@src/store/slices/global";
import { contactSupport } from "@src/utils/contactSupport";
import { carrierServices } from "@src/utils/linkSheet";
import { openNewTab } from "@src/utils/openNewTab";

export const ThirdPartyCarrierWarningDialog = () => {
  const isOpen = useSelector(isDialogOpen("thirdPartyCarrierWarning"));
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(setDialog({ dialog: "thirdPartyCarrierWarning", open: false }));
  };

  return (
    <IgDialog
      title={"Heads up!"}
      handleClose={handleClose}
      showDialog={isOpen}
      showCloseIcon={true}
      dialogContentWidth={"420px"}
      dialogHeight={null}
      maxWidth={"md"}
      yesButtonText={"Close"}
      noButtonText={null}
      rawContent={
        <Grid item>
          <IgTypography>
            We noticed you might not have Shopify's third-party carrier feature
            enabled. This feature is required to preview and launch an
            Intelligems shipping experiment. Please confirm that 'Intelligems
            Shipping' was added under 'Carrier and app rates' in your selected
            shipping zones. It's enabled by default for those on Shopify
            Advanced and Plus, and is available to merchants on the "Shopify"
            plan for either a monthly fee or by switching to yearly billing. You
            can request it by contacting Shopify support. Learn more{" "}
            <IgTypography
              igStyle={"link"}
              onClick={() => {
                openNewTab(carrierServices);
              }}
            >
              here
            </IgTypography>{" "}
            or{" "}
            <IgTypography
              igStyle={"link"}
              onClick={() => {
                contactSupport();
              }}
            >
              contact us
            </IgTypography>{" "}
            with any questions!
          </IgTypography>
        </Grid>
      }
    />
  );
};
